import React from 'react';
import { Package, ArrowRight, Check, Truck } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { useAuth } from '../../context/AuthContext';

const OrderTrackingPage = () => {
  const { login } = useAuth();
  const features = ['Rastreamento em tempo real', 'Notificações de status', 'Integração com transportadoras', 'Atualizações automáticas'];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-28 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-indigo-100 text-indigo-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
                <Package className="h-4 w-4" />Rastreamento
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                <span className="text-indigo-600">Rastreamento</span> de pedidos
              </h1>
              <p className="text-xl text-gray-600 mb-8">Clientes consultam o status do pedido diretamente pelo WhatsApp.</p>
              <Button onClick={login} size="lg" className="bg-[#3b82f6] hover:bg-[#2563eb]">Começar gratuitamente</Button>
            </div>
            <div className="bg-indigo-50 rounded-3xl p-6">
              <div className="bg-white rounded-2xl p-4">
                <div className="flex items-center gap-3 mb-4">
                  <Truck className="h-6 w-6 text-indigo-600" />
                  <span className="font-semibold">Pedido #12345</span>
                </div>
                <div className="space-y-3">
                  {['Pedido confirmado', 'Em separação', 'A caminho', 'Entregue'].map((s, i) => (
                    <div key={s} className={`flex items-center gap-3 ${i < 3 ? 'text-green-600' : 'text-gray-400'}`}>
                      <div className={`w-3 h-3 rounded-full ${i < 3 ? 'bg-green-500' : 'bg-gray-300'}`}></div>
                      <span className="text-sm">{s}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Recursos</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {features.map((f) => (<div key={f} className="bg-white rounded-xl p-6 shadow-sm"><Check className="h-6 w-6 text-green-500 mb-3" /><p className="font-medium text-gray-900">{f}</p></div>))}
            </div>
          </div>
        </div>
        <div className="py-16"><div className="max-w-4xl mx-auto px-4"><Card className="bg-gradient-to-br from-[#3b82f6] to-[#1d4ed8] text-white"><CardContent className="py-12 text-center"><h2 className="text-2xl font-bold mb-4">Ofereça rastreamento fácil</h2><Button onClick={login} variant="secondary" size="lg" className="bg-white text-[#3b82f6] hover:bg-gray-100">Começar agora <ArrowRight className="ml-2 h-4 w-4" /></Button></CardContent></Card></div></div>
      </main>
      <Footer />
    </div>
  );
};
export default OrderTrackingPage;
